/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MembershipStatusFromJSON, MembershipStatusToJSON, } from './MembershipStatus';
import { MinimalGroupFromJSON, MinimalGroupToJSON, } from './MinimalGroup';
/**
 * Check if a given object implements the AdminMember interface.
 */
export function instanceOfAdminMember(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    if (!('receivesEmails' in value) || value['receivesEmails'] === undefined)
        return false;
    if (!('hasPassword' in value) || value['hasPassword'] === undefined)
        return false;
    if (!('passkeyCount' in value) || value['passkeyCount'] === undefined)
        return false;
    if (!('pushSubscriptionCount' in value) || value['pushSubscriptionCount'] === undefined)
        return false;
    if (!('apiKeyCount' in value) || value['apiKeyCount'] === undefined)
        return false;
    if (!('membershipStatus' in value) || value['membershipStatus'] === undefined)
        return false;
    if (!('groups' in value) || value['groups'] === undefined)
        return false;
    return true;
}
export function AdminMemberFromJSON(json) {
    return AdminMemberFromJSONTyped(json, false);
}
export function AdminMemberFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'isActive': json['is_active'],
        'receivesEmails': json['receives_emails'],
        'hasPassword': json['has_password'],
        'passkeyCount': json['passkey_count'],
        'pushSubscriptionCount': json['push_subscription_count'],
        'apiKeyCount': json['api_key_count'],
        'membershipStatus': MembershipStatusFromJSON(json['membership_status']),
        'membershipActiveSeason': json['membership_active_season'] == null ? undefined : json['membership_active_season'],
        'instrument': json['instrument'] == null ? undefined : MinimalGroupFromJSON(json['instrument']),
        'groups': (json['groups'].map(MinimalGroupFromJSON)),
    };
}
export function AdminMemberToJSON(json) {
    return AdminMemberToJSONTyped(json, false);
}
export function AdminMemberToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
        'is_active': value['isActive'],
        'receives_emails': value['receivesEmails'],
        'has_password': value['hasPassword'],
        'passkey_count': value['passkeyCount'],
        'push_subscription_count': value['pushSubscriptionCount'],
        'api_key_count': value['apiKeyCount'],
        'membership_status': MembershipStatusToJSON(value['membershipStatus']),
        'membership_active_season': value['membershipActiveSeason'],
        'instrument': MinimalGroupToJSON(value['instrument']),
        'groups': (value['groups'].map(MinimalGroupToJSON)),
    };
}
